import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { jwtDecode } from "jwt-decode";

export interface UserProps {
  password: string;
  email: string;
}

export interface FormPassword {
  password: string;
  confirmPassword: string;
}

export interface UserToken {
  Email: string;
  AgentId: number;
}

export default function useAuth() {
  const [data, setData] = useState<UserProps>({ password: "", email: "" });
  const [formPassword, setFormPassword] = useState<FormPassword>({ password: "", confirmPassword: "" });
  const [authenticated, setAuthenticated] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const { setLoading } = useContext(LoadingContext);
  const tokenLocal = localStorage.getItem("token");

  let objUserTk: UserToken;
  if (tokenLocal) {
    objUserTk = jwtDecode(tokenLocal) as UserToken;
  } else {
    objUserTk = {} as UserToken;
  }

  const navigate = useNavigate();
  const showToast = useToast();

  function handleSetUser({ password, email }: UserProps) {
    setData({ password, email });
  }

  async function handleLogin({ email, password }: UserProps) {
    try {
      const response = await api.post("/security/auth", { email, password });
      const token = response.data?.data?.token;

      if (!token) {
        throw new Error("Token não retornado pela API");
      }

      localStorage.setItem("token", token);
      api.defaults.headers.Authorization = `Bearer ${token}`;
      setAuthenticated(true);
      navigate("/admin/index");
    } catch (error) {
      showToast("error", "Erro ao efetuar o login. Verifique suas credenciais.");
    }
  }

  async function updateUserPassword(userId: number, newPassword: string) {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      await api.patch(`/Users/${userId}/update-password`, JSON.stringify(newPassword), { headers });
      showToast("success", "Senha atualizada com sucesso.");
    } catch (error) {
      showToast("error", "Erro ao atualizar a senha. Verifique novamente mais tarde.");
      console.error("Erro ao atualizar a senha:", error);
    } finally {
      setLoading(false);
    }
  }

  async function sendResetPasswordEmail(email: string) {
    try {
      await api.post("/Users/reset-password", { email });
      showToast("success", "E-mail de redefinição de senha enviado.");
    } catch (error) {
      showToast("error", "Erro ao enviar o e-mail de redefinição de senha.");
    }
  }

  async function verifyResetCode(email: string, code: string): Promise<boolean> {
    try {
      const response = await api.post("/Users/verify-reset-code", { email, code });
      return response.data.isValid;
    } catch (error) {
      console.error("Erro ao verificar código de redefinição:", error);
      return false;
    }
  }

  async function handleLogout() {
    setAuthenticated(false);
    localStorage.removeItem("token");
    api.defaults.headers.Authorization = null;
    navigate("/auth/login");
  }

  useEffect(() => {
    if (tokenLocal) {
      api.defaults.headers.Authorization = `Bearer ${tokenLocal}`;
      setAuthenticated(true);
    }
    setLoadingButton(false);

  }, [tokenLocal]);

  return {
    authenticated,
    loadingButton,
    handleLogin,
    handleLogout,
    handleSetUser,
    data,
    objUserTk,
    formPassword,
    setFormPassword,
    // handleChangePassword,
    updateUserPassword,
    sendResetPasswordEmail,
    verifyResetCode,
  };
}
